const MAX_BYTES = 400_000;

/** Phaser canvas to a JPEG data URL, scaled down until it is under about 400KB. */
export function captureStageJpeg(): string | null {
  if (typeof document === 'undefined') return null;
  const canvas = document.querySelector<HTMLCanvasElement>('#stage canvas');
  if (!canvas || canvas.width < 2 || canvas.height < 2) return null;
  try {
    const longest = Math.max(canvas.width, canvas.height);
    let scale = longest > 960 ? 960 / longest : 1;
    for (let attempt = 0; attempt < 4; attempt += 1) {
      const shot = drawScaled(canvas, scale);
      if (!shot) return null;
      let quality = 0.72;
      let url = shot.toDataURL('image/jpeg', quality);
      while (dataUrlBytes(url) > MAX_BYTES && quality > 0.36) {
        quality = Math.round((quality - 0.08) * 100) / 100;
        url = shot.toDataURL('image/jpeg', quality);
      }
      if (dataUrlBytes(url) <= MAX_BYTES) return url;
      scale *= 0.6;
    }
    return null;
  } catch {
    return null;
  }
}

export function jpegBytesFromDataUrl(dataUrl: string): Uint8Array | null {
  const matched = /^data:image\/jpeg;base64,([A-Za-z0-9+/=\s]+)$/.exec(dataUrl);
  if (!matched?.[1]) return null;
  const binary = atob(matched[1].replace(/\s+/g, ''));
  if (binary.length < 1 || binary.length > MAX_BYTES) return null;
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index);
  return bytes;
}

function drawScaled(canvas: HTMLCanvasElement, scale: number): HTMLCanvasElement | null {
  const copy = document.createElement('canvas');
  copy.width = Math.max(1, Math.round(canvas.width * scale));
  copy.height = Math.max(1, Math.round(canvas.height * scale));
  const context = copy.getContext('2d');
  if (!context) return null;
  context.drawImage(canvas, 0, 0, copy.width, copy.height);
  return copy;
}

function dataUrlBytes(dataUrl: string): number {
  const comma = dataUrl.indexOf(',');
  if (comma < 0) return dataUrl.length;
  return Math.floor(((dataUrl.length - comma - 1) * 3) / 4);
}
